import { createContext } from 'react';

import type { PageScrollPosition } from './types';

export const PageScrollPositionContext = createContext<PageScrollPosition | undefined>(undefined);
